// extracted by mini-css-extract-plugin
module.exports = {"panel":"_3Fkxul","left":"_2yXjgm","timezone":"_3bOxFV"};